<div class="pageheader">
  <div class="page-title">
    <h1>Tracking Search - Status Events</h1>
  </div>
</div>
<div class="container container-fixed">
  <div>
    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label>Subscription</label>
          <select class="form-control" [(ngModel)]="searchObject.StatusEventSubscriptionId">
            <option [ngValue]="null">All</option>
            @for (statusEventSubscription of statusEventSubscriptions; track statusEventSubscription) {
              <option [ngValue]="statusEventSubscription.SubscriptionsId">{{statusEventSubscription.Name}}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>Event Statuses</label>
          <select class="form-control" [(ngModel)]="searchObject.StatusEventSubscriptionStatusTypeId">
            <option [ngValue]="null">All</option>
            @for (statusEventSubscriptionStatusType of statusEventSubscriptionStatusTypes; track statusEventSubscriptionStatusType) {
              <option [ngValue]="statusEventSubscriptionStatusType.Id">{{statusEventSubscriptionStatusType.Name}}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-sm-3 form-group">
        <label>Period From</label>
        <ep-datetime-picker #datepickerFrom type="datetime" (selectedDatetimeChange)="dateFromChanged($event)"></ep-datetime-picker>
      </div>
      <div class="col-sm-3">
        <label>Period To</label>
        <ep-datetime-picker #datepickerTo type="datetime" (selectedDatetimeChange)="dateToChanged($event)"></ep-datetime-picker>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <button class="btn btn-primary" type="button" (click)="search()" id="searchButton">Search</button>
      <button class="btn btn-link" type="button" (click)="reset()" id="clearButton">Reset search <ep-svg-icon icon="circle-cross"></ep-svg-icon></button>
    </div>
  </div>
</div>
